import { StepDetailsDTO } from '@ketch-com/figurehead'

export const getIdentitySpacesInitialValues = (stepDetails?: StepDetailsDTO) => {
  return { identitySpaces: stepDetails?.stepIdentitySpaces }
}
